<template>
    <div id="edi-file-upload-filters-modal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Filter Uploaded 837 Files</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-if="message" class="alert alert-danger" role="alert">{{ message }}</div>
                    <div class="container">
                        <div class="row">
                            <div class="col-sm">
                                <label for="uploadTypeFilter" class="my-auto">Upload Type</label>
                            </div>
                            <div class="col-sm">
                                <select id="uploadTypeFilter" class="custom-select custom-select-sm my-auto" :class="['mb-3', { 'text-muted' : filters.uploadType === null }]" v-model="filters.uploadType">
                                    <option value="">Any</option>
                                    <option v-for="option in options.uploadTypes" :key="'upload-type-' + option.id" :value="option.id" v-text="option.name"></option>
                                </select>
                            </div>
                        </div>
                        <div class="row my-2">
                            <div class="col-sm">
                                <label for="uploadedByFilter" class="my-auto">Uploaded By</label>
                            </div>
                            <div class="col-sm">
                                <select id="uploadedByFilter" class="custom-select custom-select-sm my-auto" :class="['mb-3', { 'text-muted' : filters.uploadedBy === null }]" v-model="filters.uploadedBy">
                                    <option value="">Any</option>
                                    <option v-for="option in options.users" :key="'upload-type-' + option.id" :value="option.id" v-text="option.last_name"></option>
                                </select>
                            </div>
                        </div>
                        <div class="row my-2">
                            <div class="col-sm">
                                <label for="processingStatusFilter" class="my-auto">Processing Status</label>
                            </div>
                            <div class="col-sm">
                                <select id="processingStatusFilter" class="custom-select custom-select-sm my-auto" :class="['mb-3', { 'text-muted' : filters.processingStatus == null }]" v-model="filters.processingStatus">
                                    <option value="">Any</option>
                                    <option v-for="option in options.statuses" :key="'processing-status-' + option.id" :value="option.id" v-text="option.name"></option>
                                </select>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between mt-3 mb-1">
                            <label class="d-inline-flex my-auto">Upload Date Range</label>
                            <div class="d-inline-flex align-items-center">
                                <input type="date" class="form-control form-control-sm" v-model="filters.beginDate">
                                <span class="mx-1">To</span>
                                <input type="date" class="form-control form-control-sm" v-model="filters.endDate">
                            </div>                                
                        </div>                                                
                    </div>                                       
                </div>
                <div class="modal-footer">
                    <a href="javascript:void(0)" class="mr-auto" @click="reset">Reset Filters</a>
                    <button type="button" class="btn btn-primary" @click="done">Done</button>
                </div>                
            </div>
        </div>
    </div>    
</template>

<script>
export default {
    props: {
        options: Object
    },
    data() { 
        return {
            filter: Function,
            filters: {
                uploadType: '',
                uploadedBy: '',
                processingStatus: '',
                beginDate: null,
                endDate: null
            },
            message: null
        }
    },
    methods: {
        show: function (filters, filter) {

            // make a copy of the filters and store the callback
            this.filters = JSON.parse(JSON.stringify(filters));
            this.filter = filter;

            $('#edi-file-upload-filters-modal').modal('show');
        },
        reset: function () {
            this.filters.uploadType = '';
            this.filters.uploadedBy = '';
            this.filters.processingStatus = '';
            this.filters.beginDate = null;
            this.filters.endDate = null;
            this.message = null;
        },
        done: function () {

            if (this.filters.beginDate <= this.filters.endDate) {
                this.filter(this.filters);
                $('#edi-file-upload-filters-modal').modal('hide');
            }
            else { 
                this.message = 'Invalid date range. End date must be greater than or equal to begin data.';
            }
        }
    },
    created() {
        eventHub.$on('show-edi-file-upload-filters', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-edi-file-upload-filters');
    },
    watch: {
        'filters.beginDate': function (newValue, oldValue) {
            if (newValue != oldValue) {
                this.filters.endDate = newValue;
            }
        }
    }           
}
</script>

<style scoped>

</style>